import React from "react";





const Category = props => (
<div className="menu-category">
    <img className="menu-category__image" src={props.img} alt=""/>
    <h3 className="menu-category__title"> {props.title} </h3>
</div>

)

export default Category;


// WEBPACK FOOTER //
// ./src/components/menu-categories.js